import React from "react";
import { Page } from "@adobe/aem-react-editable-components";

const App = (props) => {
  return (
    <div className="relative">
      <Page {...props} test="test" />
    </div>
  );
};

export default App;
